import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';

import {
  OnboardingContextActionType,
  useOnboardingContext,
  useOnboardingDispatch
} from '@/contexts/onboardingContext';
import useMixpanel from '@/hooks/useTracking/useMixpanel';
import useTranslate from '@/hooks/useTranslate';
import MobileCloseButton from '@/pages/members/components/MobileCloseButton';
import { COMPONENTS_PATH_TRANSLATION_KEY } from '@/pages/members/pages/Onboarding/constants';
import { focusClasses } from '@/ui/members/components/form/styles';

import prevSubmittedStep from '../utils/firstSkippedStep';

const BackButton = ({ disabled }: { disabled: boolean }) => {
  const onboardingContext = useOnboardingContext();
  const dispatch = useOnboardingDispatch();
  const navigate = useNavigate();
  const mixpanel = useMixpanel();
  const { t } = useTranslate(`${COMPONENTS_PATH_TRANSLATION_KEY}.BackButton`);

  const handlePrevStep = () => {
    if (onboardingContext.step > 1) {
      const currentStep = onboardingContext.step;
      const steps = onboardingContext.steps;
      const navigateTo = prevSubmittedStep(currentStep, onboardingContext.stepsSequence, steps);
      dispatch({
        type: OnboardingContextActionType.PREV_STEP
      });
      mixpanel.trackButtonPress(
        {
          buttonTitle: 'Back',
          buttonText: `Back`,
          screenName: `onboarding:${onboardingContext.stepsSequence[currentStep]}`
        },
        {
          toScreen: onboardingContext.stepsSequence[navigateTo],
          version: onboardingContext.version,
          feature: 'unified-onboarding'
        }
      );
      navigate(`/onboarding/${onboardingContext.version}/${navigateTo}`);
    }
  };

  return (
    <div>
      {onboardingContext.step > 1 && (
        <button
          aria-label={t('back')}
          className={`${focusClasses}`}
          onClick={handlePrevStep}
          type="button"
          disabled={disabled}>
          <FontAwesomeIcon icon={faChevronLeft} className="text-3xl" />
        </button>
      )}
      {onboardingContext.step == 1 && <MobileCloseButton />}
    </div>
  );
};

export default BackButton;
